import { render, staticRenderFns } from "./Steps.vue?vue&type=template&id=5e6f81a0&"
import script from "./Steps.vue?vue&type=script&lang=js&"
export * from "./Steps.vue?vue&type=script&lang=js&"
import style0 from "./Steps.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Steps: require('/home/runner/work/myody_front/myody_front/components/steps/Steps.vue').default})
